import styled from 'styled-components'

export const Wrapper = styled.div<{ negative?: boolean }>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  font-weight: var(--font-medium);
  background: #f6ffe0;
  padding: 15px;
  width: 100%;
  box-sizing: border-box;
  border-radius: 4px;
  color: #a2bd65;

  svg {
    width: 18px;
    color: var(--green);
    flex-shrink: 0;
  }

  ${({ negative }) =>
    negative &&
    `
    background: var(--grey-10);
    color: var(--grey-50);
    
    svg {
      color: var(--grey-50);
    }
  `}
`

export const PolicyText = styled.span`
  font-weight: var(--font-bold);
  display: block;
  font-size: 13px;
  line-height: 1.2;
`
